module.exports = __webpack_public_path__ + "img/熊猫-3.ba37d6a3.png";